<div class="px-4 sm:px-8 py-6 max-w-6xl mx-auto">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row justify-between items-center gap-4" style="margin-bottom: 24px;">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px; flex-shrink: 0;">people</mat-icon>
      <div>
        <h1 style="font-size: 1.4rem; font-weight: 700; color: #1f2937; margin: 0;">Beneficiarios</h1>
        <p style="font-size: 0.8rem; color: #6b7280; margin: 2px 0 0;">Gestiona tus cuentas de beneficiarios</p>
      </div>
    </div>
    <button type="button" (click)="openCreateDialog()"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">add_circle</mat-icon>
      Agregar Beneficiario
    </button>
  </div>

  <app-account-list
    [listaCuentas]="listaCuentas"
    [seleccionable]="seleccionable"
    (seleccion)="onSeleccion($event)"
    (reloadAccountList)="reloadAccount()"
    (actualizarCuenta)="openCreateDialog($event)">
  </app-account-list>

</div>
